import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createAnnouncement,
  deleteAnnouncement,
  getAllAnnouncements,
  getOne,
  updateAnnouncement,
  updateAnnouncementStatus,
  uploadMediaService,
} from "../../services/announcementService";
export const fetchAnnouncements = createAsyncThunk(
  "announcement/fetchAnnouncement",
  async (query, thunkAPI) => {
    try {
      // Remove undefined/null values
      const cleanedQuery = Object.fromEntries(
        Object.entries(query).filter(([_, v]) => v !== undefined && v !== null)
      );

      // Convert object to URL params
      const params = new URLSearchParams(cleanedQuery).toString();

      console.log("Params:", params);

      const data = await getAllAnnouncements(params);
      return data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addAnnouncement = createAsyncThunk(
  "announcement/addAnnouncement",
  async (announcementsData, thunkAPI) => {
    try {
      console.log(announcementsData);
      const data = await createAnnouncement(announcementsData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const editAnnouncement = createAsyncThunk(
  "announcement/editAnnouncement",
  async ({ id, announcementData }, thunkAPI) => {
    try {
      const data = await updateAnnouncement(id, announcementData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const removeAnnouncement = createAsyncThunk(
  "announcement/removeAnnouncement",
  async (id, thunkAPI) => {
    try {
      await deleteAnnouncement(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadMedia = createAsyncThunk(
  "announcement/uploadMedia",
  async (formData, thunkAPI) => {
    try {
      return await uploadMediaService(formData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAnnouncementById = createAsyncThunk(
  "announcement/fetchAnnouncementById",
  async (id, thunkAPI) => {
    try {
      console.log(id);
      const response = await getOne(id);

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateAnnouncementStatusThunk = createAsyncThunk(
  "announcement/updateStatus",
  async ({ id, status }, thunkAPI) => {
    try {
      const response = await updateAnnouncementStatus(id, status);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
const initialState = {
  announcements: [],
  currentAnnouncement: null, // Added current announcement state
  total: 0,
  totalPages: 1,
  currentPage: 1,
  loading: false,
  currentLoading: false, // Added loading state for single announcement
  error: null,
  currentError: null, // Added error state for single announcement
  uploadLoading: false,
  uploadError: null,
  uploadedMedia: [],
  filters: {
    arrivalDate: null,
    departureDate: null,
    bedrooms: null,
  },
};

const announcementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {
    clearUploadedMedia: (state) => {
      state.uploadedMedia = [];
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        arrivalDate: null,
        departureDate: null,
        bedrooms: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnouncements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnnouncements.fulfilled, (state, action) => {
        state.loading = false;
        state.announcements = action.payload.items || [];
        state.total = action.payload.totalItems || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.totalPages = action.payload.totalPages || 1;
      })
      .addCase(fetchAnnouncements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addAnnouncement.fulfilled, (state, action) => {
        state.announcements.unshift(action.payload);
      })

      .addCase(editAnnouncement.fulfilled, (state, action) => {
        state.announcements = state.announcements.map((announcement) =>
          announcement.id === action.payload.id ? action.payload : announcement
        );
      })

      .addCase(removeAnnouncement.fulfilled, (state, action) => {
        state.announcements = state.announcements.filter(
          (announcement) => announcement.id !== action.payload
        );
      })

      .addCase(uploadMedia.pending, (state) => {
        state.uploadLoading = true;
        state.uploadError = null;
      })
      .addCase(uploadMedia.fulfilled, (state, action) => {
        state.uploadLoading = false;
        if (action.payload.success && action.payload.data.media) {
          state.uploadedMedia = [
            ...state.uploadedMedia,
            ...action.payload.data.media,
          ];
        }
      })
      .addCase(uploadMedia.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.payload;
      })

      .addCase(fetchAnnouncementById.pending, (state) => {
        state.currentLoading = true;
        state.currentError = null;
      })
      .addCase(fetchAnnouncementById.fulfilled, (state, action) => {
        state.currentLoading = false;
        state.currentAnnouncement = action.payload;
      })
      .addCase(fetchAnnouncementById.rejected, (state, action) => {
        state.currentLoading = false;
        state.currentError = action.payload;
      })

      .addCase(updateAnnouncementStatusThunk.fulfilled, (state, action) => {
        const index = state.announcements.findIndex(
          (announcement) => announcement._id === action.payload._id
        );
        if (index !== -1) {
          state.announcements[index] = action.payload;
        }
        if (
          state.currentAnnouncement &&
          state.currentAnnouncement._id === action.payload._id
        ) {
          state.currentAnnouncement = action.payload;
        }
      });
  },
});

export const { clearUploadedMedia, setFilters, clearFilters } =
  announcementSlice.actions;
export default announcementSlice.reducer;
